import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
  HttpClient,
  HttpHeaders,
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { retryWhen, delay, take, tap, concat, catchError, map } from 'rxjs/operators'
import { Observable, of, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  private endpoint = environment.endpoint;
  private url = this.endpoint;

  private devendpoint = environment.cargaendpoint;

  constructor(private httpclient: HttpClient,) { }

  list(type: string, mode: string, token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'x-api-key': environment.apiKey
      })
    };

    return this.httpclient.get(this.url + '/' + mode + '/' + type, httpOptions)
  }

  createx(type: string, data: any, mode: string, token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'x-api-key': environment.apiKey
      })
    };

    return this.httpclient.post(this.url + '/' + mode + '/' + type, JSON.stringify(data), httpOptions)
  }

  update(type: string, device: string, mode: string, token) {
    const url = this.url + '/' + mode + '/' + type + '/' + device['deviceId'];

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'x-api-key': environment.apiKey
      })
    };

    return this.httpclient.put(url, device, httpOptions)
  }

  delete(type: string, id: string, mode: string, token) {
    const url = this.url + '/' + mode + '/' + type + '/' + id;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'x-api-key': environment.apiKey
      })
    };

    return this.httpclient.delete(url, httpOptions);
  }

  create(device, token) {
    //If device info is null set value
    if (!device) {
      device = {
        deviceName: 'PC',
        deviceToken: token,
        deviceType: 'Web',
        type: "",
        username: "",
      };
    }

    // const url = this.url + '/v1/custom-ecarga/device-token'; // for staging
    // let withoutv1 = environment.type === 'dev' ? this.url.split("/v1.0") : this.url
    // const url = withoutv1[0] + '/custom-ecarga/notification-query/'

    // let url_env = environment.type === 'stg' ? this.url+'/v1.0' : this.url
    // let url_env = environment.type === 'stg' ? this.url : this.devendpoint
    // const url = url_env + '/custom-ecarga/device-token'
    // // // console.log("withoutv1", url);

    // let withoutv1 = environment.type === 'stg' ? this.url.split("/v2") : this.devendpoint
    // // // console.log("withoutv1", withoutv1)
    // const url_format = withoutv1[0] + '/v1'
    // const url = url_format + '/custom-ecarga/device-token'

    let withoutv1 = environment.type === 'stg' || environment.type === 'prod' ? this.url.split("/v2") : [this.devendpoint]
    // // // console.log("withoutv1", withoutv1)
    const url_format = withoutv1[0] + '/v1'
    const url = url_format + '/custom-ecarga/device-token'
    // // console.log("create without v2", url);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'x-api-key': environment.apiKey
      })
    };

    return this.httpclient.post(url, device, httpOptions)

  }

  remove() {

    let token_ = localStorage.getItem('authToken')
    let deviceToken =  JSON.parse(localStorage.getItem('deviceToken'))
    // // console.log("token_", token_, "deviceToken", deviceToken)
    
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token_,
        'x-api-key': environment.apiKey
      })
    };

    let withoutv1 = environment.type === 'stg' ? this.url.split("/v2") : this.devendpoint
    // // console.log("withoutv1", withoutv1)
    const url_format = withoutv1[0] + '/v1'

    const url2 = `${url_format}/custom-ecarga/device-token/${deviceToken}`
    // // console.log("withoutv", url2);

    return this.httpclient.delete(url2, httpOptions)
  }

}
